import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

import {
  getSectionNavColor,
  getSectionNavMediumColor
} from 'styles/helpers/getThemeStyles';

const MAX_LENGTH = 30;

const DesignAndCustomizationStyledLabel = styled(Typography, {
  shouldForwardProp: muiPropForwarding('highlighted')
})(({ theme, highlighted }) => ({
  color: highlighted
    ? getSectionNavColor(theme)
    : getSectionNavMediumColor(theme),
  textAlign: 'left',
  fontSize: 14,
  [theme.breakpoints.up('xs')]: {
    paddingBottom: '7px',
    lineHeight: 1.2,
    fontSize: 16,
    borderBottom: `2px ${
      highlighted ? theme.palette.sectionNav.accent.main : 'transparent'
    } solid`
  }
}));

const MenuSectionsNavLinkLabel = ({ highlighted, children }) => {
  const styles = { variant: 'sectionNav', highlighted };

  return (
    <DesignAndCustomizationStyledLabel {...styles}>
      {children.length > MAX_LENGTH
        ? children.slice(0, MAX_LENGTH) + '...'
        : children}
    </DesignAndCustomizationStyledLabel>
  );
};

MenuSectionsNavLinkLabel.defaultProps = {
  fullWidth: false
};
MenuSectionsNavLinkLabel.propTypes = {
  highlighted: PropTypes.bool,
  children: PropTypes.node
};

export default MenuSectionsNavLinkLabel;
